export default [
  {
    modulId: "photovoltaikModul",
    modulPrefix: "Zusätzlich Absichern",
    anzeigen: true,
    aktiv: true,
    inaktivText: "",
    preisId: "BL_PHOTOVOLTAIK",
    name: "Photovoltaik",
    nameMakler: "Photovoltaik",
    icon: "icon-solar-panels",
    info: "",
    body:
      '<div class="o-grid__cell o-grid__cell--9">' +
      '<ul class="c-list">' +
      '<li class="c-list__item">bis 25 kWp</li>' +
      "</ul>" +
      "</div>",
  },
];
